import { AgentCapability } from '../../types';

/**
 * App code for AI agent features
 */
export const AGENT_APP_CODE = 'BAI';

/**
 * Maps portal feature UUIDs to agent capabilities
 * These feature codes determine which agent capabilities are enabled for a portal
 */
export const AGENT_CAPABILITY_FEATURE_MAP: Record<AgentCapability, string> = {
	ENRICHMENT_AGENT: '77bffcde-d070-4e20-89dd-6e457423270b',
	TRANSFORMATION_AGENT: '14ec01b6-dd6c-401c-8d6b-e5fc699c328c',
	BRAND_COMPLIANCE_AGENT: '099df46f-12b8-450e-8091-a82a44e2e021',
	GOVERNANCE_AGENT: '99bc5e9c-a871-4f28-ade3-bbb49e154f48',
	PATH_GENERATOR_AGENT: '179a980d-2f66-4c7c-a0f5-1fd4aa8d8e42',
};
